export default "__VITE_ASSET__CTii3ebL__"